import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";

type AttendancesMobileHeaderProps = {
  primaryText: ReactNode;
  secondaryText: ReactNode;
  rightSide?: ReactNode;
};

export function AttendancesMobileHeader({
  primaryText,
  secondaryText,
  rightSide,
}: AttendancesMobileHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-row justify-between items-center">
      <div className="flex flex-row gap-2">
        <button onClick={() => navigate(-1)}>
          <FontAwesomeIcon className="text-lg" icon={faChevronLeft} />
        </button>
        <div className="flex flex-col">
          <div className="text-font-secondary">{secondaryText}</div>
          <div className="font-medium text-base">{primaryText}</div>
        </div>
      </div>
      {rightSide}
    </div>
  );
}
